"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreSensorStatus = exports.CoreSensorType = void 0;
var CoreSensorType;
(function (CoreSensorType) {
    CoreSensorType["OB1"] = "ob1";
    CoreSensorType["S5B"] = "s5b";
    CoreSensorType["S5"] = "s5";
    CoreSensorType["R60"] = "r60";
    CoreSensorType["R56"] = "r56";
    CoreSensorType["VIRTUAL"] = "virtual";
})(CoreSensorType = exports.CoreSensorType || (exports.CoreSensorType = {}));
var CoreSensorStatus;
(function (CoreSensorStatus) {
    CoreSensorStatus["ONLINE"] = "online";
    CoreSensorStatus["PROVISIONING"] = "provisioning";
    CoreSensorStatus["ERROR"] = "error";
    CoreSensorStatus["UNCONFIGURED"] = "unconfigured";
    CoreSensorStatus["LOW_POWER"] = "low_power";
})(CoreSensorStatus = exports.CoreSensorStatus || (exports.CoreSensorStatus = {}));
//# sourceMappingURL=sensors.js.map